import React, {} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import SttHeading from '@stt-componentes/core/dist/lib/SttTypography/SttHeading';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import mensagemErro from '../../signals/erro';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
}));

const Erro = (props) => {
    const classes = useStyles();
    const { message } = props;

    return (
        <div className={classes.root}>
            <SttHeading variant="h1">
                <ErrorOutlineIcon />
                Erro
            </SttHeading>
            {
                mensagemErro &&
                <SttHeading variant="h4">
                    {mensagemErro.value}
                </SttHeading>
            }
        </div>
    );
};

export default Erro;
